import { render, staticRenderFns } from "./AddServiceEntity.vue?vue&type=template&id=0af781cc&"
import script from "./AddServiceEntity.vue?vue&type=script&lang=js&"
export * from "./AddServiceEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports